export default __webpack_public_path__ + "static/media/directory_light.914ed4ab.svg";